import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { LandingSummarySettings, LandingSummaryTranslationKeys } from '../../../interfaces/Widget.interface';
import { DashboardingProvider } from '../../../providers/dashboarding.provider';
import { WidgetSize } from '../../../providers/widgets.contants';
import { Page, RoutingService } from '../../../services/routing/routing.service';
import { LandingSummaryComponent } from '../../landing-summary/landing-summary';
import { AbstractWidgetClass } from '../AbstractWidget.class';

@Component({
    styleUrls: ['./widget-budget-vision.scss'],
    selector: 'widget-budget-vision',
    templateUrl: 'widget-budget-vision.html',
    imports: [LandingSummaryComponent, TranslatePipe]
})
export class WidgetBudgetVisionComponent extends AbstractWidgetClass<LandingSummaryTranslationKeys, LandingSummarySettings> {
    private _routingService = inject(RoutingService);
    private _dashboardingProvider = inject(DashboardingProvider);

    size = WidgetSize.HALF;

    navigateToFunnel() {
        this._routingService.goTo(Page.BUDGET_FUNNEL_VIEW, {
            timeseriesIndicator: this.config.timeseriesIndicator,
            dashboardRight: this._dashboardingProvider.getSelectedLegacyDashboard()!.dashboardRight
        });
    }
}
